import { BrokerCommunication } from "@dune/types";
import type { PaginatedResponse } from "@dune/types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axios";
import { communicationsQueryKeys } from "../query-keys/communications.query-keys";

export interface GetAllCommunicationsParams {
	page?: number;
	limit?: number;
	sortBy?: string;
	sortOrder?: "asc" | "desc";
	filters?: string;
	search?: string;
}

export const getAllCommunications = async (
	params?: GetAllCommunicationsParams,
): Promise<PaginatedResponse<BrokerCommunication>> => {
	const { data } = await privateAxios.get<
		PaginatedResponse<BrokerCommunication>
	>("/communications", { params });
	return data;
};

export const useGetAllCommunications = (
	params?: GetAllCommunicationsParams,
) => {
	return useQuery({
		queryKey: communicationsQueryKeys.allWithParams(params),
		queryFn: () => getAllCommunications(params),
		staleTime: 30 * 1000,
	});
};

const getCommunicationsCount = async (): Promise<{ count: number }> => {
	const { data } = await privateAxios.get<{ count: number }>(
		"/communications/count",
	);
	return data;
};

export const useGetCommunicationsCount = (options?: {
	enabled?: boolean;
}) => {
	return useQuery({
		queryKey: communicationsQueryKeys.count(),
		queryFn: getCommunicationsCount,
		staleTime: 60_000,
		refetchInterval: 60_000,
		enabled: options?.enabled ?? true,
	});
};
